export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8596.388a53b4.jpg";